import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import BugZeroLogo from '../bz/BugZeroLogo';

const HEIGHT_FOR = {
  auth: 32,
  'navbar-vertical': 24,
  'navbar-top': 22
};

const Logo = ({ at = 'auth', className, ...rest }) => (
  <Link
    to="/"
    className={classNames(
      'text-decoration-none',
      { 'navbar-brand text-left': at === 'navbar-vertical' || at === 'navbar-top' }
    )}
    {...rest}
  >
    <div
      className={classNames(
        'd-flex',
        {
          'align-items-center py-3': at === 'navbar-vertical',
          'align-items-center': at === 'navbar-top',
          'justify-content-center mb-4': at === 'auth'
        },
        className
      )}
    >
      <BugZeroLogo height={HEIGHT_FOR[at] || 24} />
    </div>
  </Link>
);

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  className: PropTypes.string
};

export default Logo;
